import { render } from "./createRole.vue?vue&type=template&id=cdfdf2ac&scoped=true"
import script from "./createRole.vue?vue&type=script&lang=js"
export * from "./createRole.vue?vue&type=script&lang=js"

import "./createRole.vue?vue&type=style&index=0&id=cdfdf2ac&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdfdf2ac"]])

export default __exports__